module.exports = __webpack_public_path__ + "img/bst_ch_malagor_0.63f45bfb.png";